module.exports = __webpack_public_path__ + "static/media/medium-m-color-100px.4fa42ea5.png";